module.exports = __webpack_public_path__ + "img/square-iron-on.a92225b7.jpg";